<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>盲盒配置</span>
          <clear-cache-apply />
          <sync-data />
          <!--          <CommonExport :export-title="'导出'" :import-title="'导入'" :import-p="'config:blindBox:import'" :export-p="'config:blindBox:export'" :get-table="getTables" :import-method="importBuildBoxCfg" :export-method="exportBuildBoxCfg" />-->
        </div>

        <el-form :inline="true" class="demo-form-inline">
          <el-row v-for="(item, index) in formData" :key="index">
            <!--            <el-form-item label="ID">-->
            <!--              <el-input v-model.number="item.id" readonly style="width: 100px;" placeholder="宝箱ID" />-->
            <!--            </el-form-item>-->
            <el-form-item label="宝箱名称">
              <el-input v-model="item.name" style="width: 150px;" placeholder="宝箱名称" />
            </el-form-item>
            <el-form-item label="皮肤资源ID">
              <el-input v-model.number="item.skinResourceId" style="width: 150px;" placeholder="皮肤资源ID" />
            </el-form-item>
            <el-form-item label="配置">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="langVisibleArr[index].visible = true" />
              <el-drawer direction="rtl" :before-close="(d)=>handleClose(d,index)" size="1050px" :visible="langVisibleArr[index].visible">
                <Reward :id="item.id" v-model="item.reward.data" :refresh-tables="getTables" />
              </el-drawer>
            </el-form-item>
            <el-form-item>
              <el-button v-permisaction="['config:blindBox:del']" type="danger" size="mini" @click="del(item.id, index)">删除</el-button>
            </el-form-item>
          </el-row>

          <el-button v-permisaction="['config:blindBox:add']" type="primary" @click="add()">+</el-button>
          <el-button v-permisaction="['config:blindBox:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import {
  delBuildBoxCfg,
  exportBuildBoxCfg, getBuildBoxCfg,
  importBuildBoxCfg,
  updateBuildBoxCfg
} from '@/api/config/blind-box-cfg'
import Reward from '@/views/config/blind-box-config/component/reward.vue'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'BlindBox',
  components: {
    SyncData,
    ClearCacheApply,
    Reward
  },
  data() {
    return {
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      langVisibleArr: [{ visible: false }],
      rewardType: [],
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      formData: [
        {
          id: 0,
          name: '',
          skinResourceId: 0,
          reward: {
            data: [
              {
                propsId: 1,
                num: 1,
                skin: 1,
                pro: [{
                  lv: 1,
                  weight: [
                    { num: 0, v: 0 }
                  ]
                }]
              }
            ]
          }
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    exportBuildBoxCfg,
    importBuildBoxCfg,
    handleClose(d, index) {
      this.langVisibleArr[index].visible = false
    },
    onSubmit() {
      for (const i in this.formData) {
        const _data = this.formData[i]
        if (_data.name === '') {
          this.msgError('名称不能为空')
          return false
        }
      }
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateBuildBoxCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getBuildBoxCfg(this.queryParams).then(res => {
        res.data.list.forEach((item, index) => {
          if (item.reward === null) {
            res.data.list[index].reward = {
              data: [
                {
                  propsId: 1,
                  num: 1,
                  skin: 1,
                  v: 1,
                  pro: []
                }
              ]
            }
          }
          this.langVisibleArr.push({
            visible: false
          })
        })
        this.formData = res.data.list
        this.total = res.data.count
      })
    },
    removeReward(index, zIndex) {
      this.formData[index].reward = this.formData[index].reward.filter((item, i) => {
        return i !== zIndex
      })
    },
    add() {
      this.formData.push({
        id: 0,
        name: '',
        skinResourceId: 0,
        reward: {
          data: [
            {
              propsId: 1,
              num: 1,
              skin: 1,
              v: 1,
              pro: [{
                lv: 1,
                weight: [
                  { num: 0, v: 0 }
                ]
              }]
            }
          ]
        }
      })

      this.langVisibleArr.push({
        visible: false
      })
    },
    del(id, index) {
      if (id <= 0) {
        this.formData = this.formData.filter((item, idx) => {
          return idx !== index
        })
      } else {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delBuildBoxCfg({ id: id }).then(res => {
            this.getTables()
            this.msgSuccess(res.msg)
          })
        })
      }
    }
  }
}
</script>

<style scoped>
table {
  border-collapse: collapse; /* 合并边框 */
}

td {
  border: 1px solid #ccc; /* 单元格边框样式 */
  padding: 5px; /* 单元格内边距 */
  height: 30px;
  width: 100px;
  text-align: center;
}
</style>
